import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LabelValueStats extends Component {
  render() {
    return (
      <section className="label-stats__internal">
        <h1 className="label-stats__title">{this.props.sectionTitle}</h1>
        <table className="table">
          <thead>
            <tr>
              <th>{this.props.title}</th>
              <th>Contador</th>
            </tr>
          </thead>
          <tbody>
            {this.props.list.map(i => (
              <tr key={i.label}>
                <td>{i.label}</td>
                <td>{i.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    );
  }
}

LabelValueStats.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
};

export default LabelValueStats;



// WEBPACK FOOTER //
// ./src/components/LabelValueStats/index.js